import { render, staticRenderFns } from "./form.vue?vue&type=template&id=736c5641&scoped=true&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"
import style0 from "./form.vue?vue&type=style&index=0&id=736c5641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736c5641",
  null
  
)

export default component.exports